import { useState } from 'react';
import styled from 'styled-components';
import { useRoutes, useTokenData } from 'hooks';
import { useDispatch } from 'react-redux';
import { Link as RouterLink } from 'components/common/link';
import { LoginButton } from 'components/login-button';
import { ROUTE_PATHS } from 'routes';
import { color, isMobile, theme } from 'constants/styled-theme';
import AdminTabBar from 'components/tab-bar/admin-tab-bar';
import FaqTabBar from 'components/tab-bar/faq-tabs';
import Tab from 'components/tab-bar/tab';
import { changeTab } from 'components/active-auctions/actions';
import TabBar from '../tab-bar';

const Header = styled.div`
  padding: 15px;
  position: fixed;
  width: 100%;
  background: ${color('backgroundMenuColor')};
  z-index: 10;
  box-shadow: ${theme.basicShadow};
  top: 0;
  left: 0;
  box-sizing: border-box;
  @media (max-width: ${p => p.theme.mobile}) {
    display: none;
  }
`;
const NavRow = styled.div`
  display: flex;
  justify-content: space-between;
  flex-wrap: nowrap;
  height: 55px;
`;
const RapLogo = styled.div`
  font-size: 30px;
  font-family: ${props => props.theme.fonts.bold};
  color: ${color('red50')};
  @media (min-width: 1024px) and (max-width: 1300px) {
    font-size: 23px;
  }
`;
const JewelLogo = styled.div`
  font-size: 18px;
  font-family: ${props => props.theme.fonts.bold};
  @media (min-width: 1024px) and (max-width: 1300px) {
    font-size: 12px;
  }
`;
const Links = styled.div`
  display: flex;
  align-items: center;
`;

const TabRoute = styled(RouterLink)`
  margin: 15px;
  font-size: 18px;
  font-family: ${props => props.theme.fonts.regular};
  font-family: 'Montserrat', sans-serif;
  color: ${prop => (prop.selected ? color('activeMenuColor') : color('menuFontColor'))};
  border-bottom: ${prop => (prop.selected ? `solid 3px ${color('activeMenuColor')}` : 'none')};
  :hover {
    border-bottom: solid 3px
      ${prop => (prop.selected ? color('activeMenuColor') : color('mainMenuHoverLine'))};
  }

  @media (min-width: 1024px) and (max-width: 1300px) {
    font-size: 13px;
    padding: 0 6px;
  }
  @media (max-width: ${p => p.theme.mobile}) {
    font-size: 12px;
  }
`;
const LogIn = styled.div`
  display: flex;
  align-items: center;
`;

export const HeaderBar = () => {
  const dispatch = useDispatch();
  const { isFaqTab, isAdminTab, isMyAccountTab, isCatalog, isHomeRoute } = useRoutes();
  const { isSeller, isBuyer, isAdmin, isAuth } = useTokenData();
  const [showSubTabs, setShowSubTabs] = useState({
    about: false,
    admin: false,
    account: false
  });

  return (
    <Header id="headerBar">
      <div>
        <NavRow>
          <RouterLink to="/">
            <RapLogo>RAPAPORT</RapLogo>
            <JewelLogo>{`JEWELRY ${isCatalog ? 'COLLECTION' : 'AUCTIONS'}`}</JewelLogo>
          </RouterLink>
          <Links>
            <TabRoute
              onClick={() => {
                dispatch(changeTab());
              }}
              selected={!!isHomeRoute}
              to={ROUTE_PATHS.ACTIVE_AUCTIONS}
              onMouseEnter={() => {
                setShowSubTabs({ ...showSubTabs, account: false, admin: false, about: false });
              }}
              target="_self"
            >
              HOME
            </TabRoute>
            <Tab to={ROUTE_PATHS.ABOUT} target="_self">
              ABOUT
            </Tab>
            <Tab
              onClick={() => {
                dispatch(changeTab());
              }}
              to={ROUTE_PATHS.ACTIVE_AUCTIONS}
              onMouseEnter={() => {
                setShowSubTabs({ ...showSubTabs, account: false, admin: false, about: false });
              }}
            >
              {!isCatalog ? 'AUCTION' : 'COLLECTIONS'}
            </Tab>
            {isAuth && (
              <Tab
                selected={!!isMyAccountTab}
                to={(isSeller && ROUTE_PATHS.MY_LOTS) || (isBuyer && ROUTE_PATHS.MY_BIDS)}
                onClick={() => {
                  dispatch(changeTab());
                }}
                onMouseEnter={() => {
                  setShowSubTabs({ ...showSubTabs, account: true, admin: false, about: false });
                }}
              >
                MY ACCOUNT
              </Tab>
            )}
            <Tab
              selected={!!isFaqTab}
              to={ROUTE_PATHS.HOW_IT_WORKS}
              onMouseEnter={() => {
                setShowSubTabs({ ...showSubTabs, account: false, admin: false, about: true });
              }}
            >
              HOW IT WORKS
            </Tab>
            <Tab
              to={ROUTE_PATHS.CONTACT}
              onMouseEnter={() => {
                setShowSubTabs({ ...showSubTabs, account: false, admin: false, about: false });
              }}
            >
              CONTACT
            </Tab>
            {isAdmin && (
              <Tab
                selected={isAdminTab}
                to={ROUTE_PATHS.MY_AUCTIONS}
                onMouseEnter={() => {
                  setShowSubTabs({ ...showSubTabs, account: false, admin: true, about: false });
                }}
              >
                ADMIN
              </Tab>
            )}
          </Links>
          <LogIn>{!isMobile && <LoginButton />}</LogIn>
        </NavRow>
        {((isAdminTab && !showSubTabs.account && !showSubTabs.about) || showSubTabs.admin) && (
          <AdminTabBar
            onMouseLeave={() => {
              setShowSubTabs({ ...showSubTabs, account: false, admin: false, about: false });
            }}
          />
        )}
        {((isMyAccountTab && !showSubTabs.admin && !showSubTabs.about) || showSubTabs.account) && (
          <TabBar
            onMouseLeave={() => {
              setShowSubTabs({ ...showSubTabs, account: false, admin: false, about: false });
            }}
          />
        )}
        {((isFaqTab && !showSubTabs.admin && !showSubTabs.account) || showSubTabs.about) && (
          <FaqTabBar
            onMouseLeave={() => {
              setShowSubTabs({ ...showSubTabs, account: false, admin: false, about: false });
            }}
          />
        )}
      </div>
    </Header>
  );
};

HeaderBar.propTypes = {};
